import { GlobalAppPropsHeader } from '@juvare/common-web-ui/GlobalApp/types';
import { EnvironmentConfig } from '../../backend/types/extraTypes';

declare global {
    interface Window {
        appName: string;
        appPublicUrl: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        pendo: any;
    }
}
export const appName = window.appName;
export const baseName = window.appPublicUrl;
export const pendo = window.pendo;

export function getGlobalHeaderEnvironment(config: EnvironmentConfig): GlobalAppPropsHeader['environment'] {
    switch (config.environment) {
        case 'local':
        case 'dev':
        case 'lab':
        case 'demo':
            return config.environment;
        default:
            return undefined;
    }
}
